import React from 'react'
import leftImg from '../../../assets/img/Left.png'
import { withShoppingCartContainer } from '../../containers/gamification';
import { matchPath } from 'react-router-dom';

const CartStep = ({to, exact, activeClassName, className, children}) => {

  const options = {
    exact: exact,
    path: to
  }

  const isActive = !!matchPath(window.location.pathname, options)

  const stepClass = ['px-0 md:px-2', className, isActive && activeClassName].join(' ')

  return(
    <p className={stepClass}> {children} </p>
  )
}

const CartNavigation = props => {

  return (
    <nav className='g-cart__navbar text-sm md:text-lg justify-between flex items-center text-center py-5 mb-5'>
      <CartStep
        exact to='/cart'
        activeClassName='g-cart__navbar-active'
        className='link-reset py-1 sm:py-0'
        >
          <span>1. Encomenda</span>
          <i className="px-1 fas fa-chevron-right"></i>
      </CartStep>
      <CartStep
        exact to='/cart/address'
        activeClassName='g-cart__navbar-active'
        className='link-reset py-1 sm:py-0'
        >
          <span>2. Entrega</span>
          <i className="px-1 fas fa-chevron-right "/>
      </CartStep>
      <CartStep
        to='/cart/checkout'
        activeClassName='g-cart__navbar-active'
        className='link-reset py-1 sm:py-0'
        >
          <span>3. Confirmação</span>
          <i className="px-1 fas fa-chevron-right "/>          
      </CartStep>
    </nav>
  )
}

export default withShoppingCartContainer(CartNavigation);
